import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button } from 'react-aria-components';

import ListingFilterNew from '@/features/listing/components/listings-filters/listing-filter-new/listing-filter-new';
import styles from '@/features/listing/components/listings-filters/listing-type-filter/listing-type-filter.module.scss';
import { LISTINGS_SORT } from '@/features/listing/constants/listings-filters-constants';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import { useRouter } from '@/i18n/routing';

interface ListingSortProps {
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  }
}

export default function ListingSort(props: ListingSortProps) {
  const {
    filterLink,
    onFilterDisplayChange,
  } = props;

  const router = useRouter();
  const searchParams = useSearchParams();
  const currentValue = searchParams.get(LISTINGS_SORT.name) ?? 'LastActivity';

  const translationsFilterTitles = useTranslations('listing.filters.filter-titles');
  const translationsFilterSort = useTranslations('listing.filters.sort');

  const [isPopoverOpen,
    setPopoverOpen] = useState(false);

  const handleChange = (value: string) => () => {
    onFilterDisplayChange(null);
    setPopoverOpen(false);

    filterLink.searchParams.set(LISTINGS_SORT.name, value);
    router.push(`${filterLink.pathname}?${filterLink.searchParams.toString()}`);
  };

  const currentSortOption = LISTINGS_SORT.options.find((sort) => sort.value === currentValue);

  return (
    <ListingFilterNew
      // @ts-expect-error - add all possible values
      buttonText={`${translationsFilterTitles('sort-by')}: ${translationsFilterSort(currentSortOption?.label ?? 'last-activity')}`}
      dialogTitle={translationsFilterTitles('sort-by')}
      onFilterDisplayChange={onFilterDisplayChange}
      listingFilterName="listingsSort"
      isPopoverOpen={isPopoverOpen}
      setPopoverOpen={setPopoverOpen}
    >
      {LISTINGS_SORT.options.map((option) => (
        <Button
          key={option.value}
          className={styles.filterToggle}
          onPress={handleChange(option.value)}
          isDisabled={option.value === currentValue}
        >
          {/* @ts-expect-error - need to add all possible values */}
          {translationsFilterSort(option.label)}
        </Button>
      ))}
    </ListingFilterNew>
  );
}
